/* unplugin-vue-components disabled */import script from "./evaluationProjectSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./evaluationProjectSettings.vue?vue&type=script&setup=true&lang=js"

import "./evaluationProjectSettings.vue?vue&type=style&index=0&id=c978b466&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c978b466"]])

export default __exports__